import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  & + & {
    margin-top: var(--space-sm);
  }
`;

const Content = styled.div`
  padding: var(--space-sm) 0;
  width: 100%;
`;

const FilterWrapper = ({ className, children }) => (
  <Wrapper className={className}>
    <Content>{children}</Content>
  </Wrapper>
);

FilterWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

FilterWrapper.defaultProps = {
  className: '',
};

export default FilterWrapper;
